import { ApiBase, isFilter } from '.';
import { ChartImages, ChartImagesRequest, CurveCalculationResult, DcsRequest, DcsResponse, DebugFilter, FileModel, Filter, FilterValues, MesRequest, ServiceResponse } from '../models';
import { ClientMotorRequest } from '../models/ClientMotorRequest';
import { ClientMotorResponse } from '../models/ClientMotorResponse';
import { CurvePointsDocumentRequest } from '../models/CurvePointsDocumentRequest';

export const joinApiUrl = (base: string | undefined, path: string) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    if (!base) {
        return normalizedPath;
    }

    return `${base.replace(/\/$/, '')}${normalizedPath}`;
};

const mesWeb = process.env.REACT_APP_BASE_URL;
const mesApi = process.env.REACT_APP_API_BASE_URL || '/api/mes';
const utilityApi = process.env.REACT_APP_UTILITY_API_BASE_URL || '/chart';

export class Api extends ApiBase {
    public static getFilterValues = (filter: Filter): Promise<ServiceResponse<FilterValues>> => {
        return Api.post(joinApiUrl(mesApi, '/getfiltervalues'), filter);
    };

    public static getMotorRequest = (filter: Filter | DebugFilter): Promise<ServiceResponse<MesRequest>> => {
        return Api.post(joinApiUrl(mesApi, `/${isFilter(filter) ? 'getmotorrequest' : 'getmotorrequestdebug'}`), filter);
    };

    public static calculateAllCurves = (mesRequest: MesRequest): Promise<ServiceResponse<CurveCalculationResult>> => {
        return Api.post(joinApiUrl(mesApi, '/allcurves'), mesRequest);
    };

    public static getChartImages = (chartImagesRequest: ChartImagesRequest): Promise<ChartImages> => {
        return Api.post(joinApiUrl(utilityApi, '/getchartimages'), chartImagesRequest);
    };

    public static getCurvePointsDocument = (request: CurvePointsDocumentRequest): Promise<ServiceResponse<FileModel>> => {
        return Api.post(joinApiUrl(mesApi, '/getcurvepointsdocument'), request);
    };

    public static getDocument = (dcsRequest: DcsRequest): Promise<ServiceResponse<DcsResponse>> => {
        return Api.post(joinApiUrl(mesApi, '/getdocument'), dcsRequest);
    };

    public static getClientDocument = (motorRequest: ClientMotorRequest): Promise<any> => {
        return Api.post(joinApiUrl(mesApi, '/getclientdocument'), motorRequest, true, false);
    };

    public static getConfiguration = (motorRequest: FormData): Promise<ServiceResponse<ClientMotorResponse>> => {
        return Api.post(joinApiUrl(mesWeb, '/getclientmotordata'), motorRequest, false);
    };

    public static getConfigurationIpc = (): Promise<ServiceResponse<ClientMotorResponse>> => {
        return Api.get(joinApiUrl(mesWeb, '/getclientmotordataipc'), true);
    };
}
